import React from 'react'
import { Form, Row, Col } from 'antd'
import { Input, Radio } from 'ui/styled'
import { Label } from 'pages/Ticket/styled'
import enumCollections from 'constants/enumCollections'

const { Item } = Form
const { Group } = Radio

const requestedByOptions =
  enumCollections.PRIOR_AUTHORIZATION_STATUS_REQUESTER.enumValues.map(item => ({
    key: item.name,
    value: item.name,
    label: item.description
  }))

const paStatusOptions =
  enumCollections.PRIOR_AUTHORIZATION_STATUS_PA_STATUS.enumValues.map(item => ({
    key: item.name,
    value: item.name,
    label: item.description
  }))

const PriorAuthorizationStatusFields = () => (
  <>
    <Row>
      <Col span={11}>
        <Label>Claim ID</Label>
        <Item name="claim_id">
          <Input placeholder="Claim ID" />
        </Item>
      </Col>
      <Col span={11} offset={1}>
        <Label>Medication</Label>
        <Item name="medication">
          <Input placeholder="Medication" />
        </Item>
      </Col>
    </Row>
    <Row>
      <Col span={11}>
        <Label required>Requested By</Label>
        <Item name="requested_by" rules={[{ required: true }]}>
          <Group options={requestedByOptions} />
        </Item>
      </Col>
      <Col span={11} offset={1}>
        <Label>MHK RX Case Number</Label>
        <Item name="mhk_rx_case_number">
          <Input placeholder="MHK RX Case Number" />
        </Item>
      </Col>
    </Row>
    <Row>
      <Col span={11}>
        <Label required>PA Status</Label>
        <Item name="pa_status" rules={[{ required: true }]}>
          <Group options={paStatusOptions} />
        </Item>
      </Col>
    </Row>
  </>
)
export default PriorAuthorizationStatusFields
